import Vue from 'vue'
import Element from 'element-ui'
import '@src/design/element-variables-v2.scss'
import locale from 'element-ui/lib/locale/lang/zh-TW'

Vue.use(Element, { locale })
